import React from 'react';
import './HorizontalVideoCard.scss';
import { cn } from '../../utils/bem';
import { Typography } from '@dataartdev/uikit/Typography';
import { Mq } from '@dataartdev/uikit/Mq';
import { Button } from '@dataartdev/uikit/Button';
import { CtaScrollerBtn } from '../CtaScrollerBtn';
import { Picture } from '@dataartdev/uikit/Picture';
import { VideoModal } from '../VideoCard/components/VideoModal';
import { useModal } from '../VideoCard/hooks/useModal';
import { Item } from '../ContentBuilder/templates/models/CTI_80.props';

const cnHorizontalVideoCard = cn('HorizontalVideoCard');

interface Props {
  demoText?: string;
  viewText?: string;
  titleLink?: string;
}

export const HorizontalVideoCardButtons: React.FC<Props> = ({
  demoText = 'Request Demo',
  viewText = 'Visit Website',
  titleLink,
}) => {
  return (
    <div className={cnHorizontalVideoCard('Buttons')}>
      <CtaScrollerBtn
        className={cnHorizontalVideoCard('Demo')}
        title={demoText || 'Request Demo'}
        view="secondary"
        link={'expert-form-01'}
        isArrow={false}
      />
      {titleLink && (
        <Button
          className={cnHorizontalVideoCard('Website')}
          view="secondary"
          as="a"
          href={titleLink}
          target={'_blank'}
          label={viewText || 'Visit Website'}
        />
      )}
    </div>
  );
};

export const HorizontalVideoCard: React.FC<Item> = ({
  title,
  titleLink,
  text,
  preview,
  video,
  demoText,
  viewText,
  // color,
  // tags,
  // tagItems,
  // industries,
  // industriesItems,
}) => {
  const { isModalOpen, openModal, closeModal } = useModal();

  return (
    <div className={cnHorizontalVideoCard()}>
      <div className={cnHorizontalVideoCard('Content')}>
        <div className={cnHorizontalVideoCard('Top')}>
          {title && (
            <Typography.Title
              size="sm"
              as="h3"
              className={cnHorizontalVideoCard('Title')}
            >
              {title}
            </Typography.Title>
          )}
          {text && (
            <Typography.Text
              size="m"
              as="p"
              className={cnHorizontalVideoCard('Description')}
            >
              {text}
            </Typography.Text>
          )}
        </div>
        <Mq query="--tablet-min">
          <HorizontalVideoCardButtons
            demoText={demoText}
            viewText={viewText}
            titleLink={titleLink}
          />
        </Mq>
      </div>
      <div
        className={cnHorizontalVideoCard('Preview', { video: !!video })}
        onClick={video ? openModal : undefined}
      >
        {video?.picture && <Picture {...video.picture} />}
        {preview && !video && <Picture {...preview} />}
      </div>
      <Mq query="--mobile">
        <HorizontalVideoCardButtons
          demoText={demoText}
          viewText={viewText}
          titleLink={titleLink}
        />
      </Mq>
      {video && (
        <VideoModal
          isModalOpen={isModalOpen}
          onClose={closeModal}
          url={video?.youTubeEmbededUrl}
        />
      )}
    </div>
  );
};
